<!-- <div class="app-modal-title">Attribute Filter</div>
<div class="app-modal-content"> -->
	<div class="qc-filter-title">
		<div class="qc-filter-title-text">Attribute Filter</div>
		<div class="filter-check-all" *ngIf="attrFilterStatus==='dirty'">
			<i class="glyphicons glyphicons-filter-remove"  title="Remove attribute filters"  (click)="removeAllAttrFilters()"></i>
		</div>
	</div>
	<div class="attribute-filters">
		<div *ngFor="let af of attrFilters;let idx = index;" class="attribute-filter-item">
			<app-common-column-filter
				#attrFilter
				id="column-filter-{{idx}}"
				[filter]="af.filter"
				[columns]="attrFilterColumns"
				[displayField]="'name'"
				isAutoCheckDomain="af.isAutoCheckDomain"
				[domainFilter]="af.domainFilters"
				(onChange)="onAttrFilterChange($event, idx)"
				>
				<!-- (onPressEnter)="applyAttrFilter()" -->
			</app-common-column-filter>
			<i [ngClass]="{'disabled-icon': attrFilters.length === 1}" class="glyphicons glyphicons-bin" (click)="removeFilter(idx)"></i>
		</div>
	</div>
	<div *ngIf="attrFilters.length < maxNumOfFilter">
		<i class="glyphicons glyphicons-plus" (click)="addEmptyFilter()"></i>
	</div>
<!-- </div>
<div class="app-modal-footer">
	<div class="button-group">
		<button class="button-general" (click)="cancel()">Cancel</button>
		<button class="button-general" (click)="applyAttrFilter()">Go</button>
	</div>
</div> -->
